module.exports = "data:image/svg+xml;base64,"


//////////////////
// WEBPACK FOOTER
// ./src/assets/test.svg
// module id = SC2M
// module chunks = 0